module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/july-6c4dfb3961f1b1c26427b4f2db5a6380.png";